var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppAliases(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-2 {\n        stroke: #323232;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4,16v2.04c0,1.1.9,2,2,2h3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4,8v-2c0-1.1.9-2,2-2h3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4,
    y1: 12,
    x2: 9,
    y2: 12
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "7 14 9 12 7 10"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.91,14.84h0s0,0,0,0c1.44,0,2.61-1.17,2.61-2.61h0v-5.47s0-.05,0-.08c-.02-1.44-1.21-2.59-2.65-2.57-1.44.02-2.59,1.21-2.57,2.65v1.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.29,16.75v1.26c-.02,1.41-1.16,2.55-2.57,2.57-1.44.02-2.63-1.13-2.65-2.57h0v-5.47s0,0,0,0c0-1.44,1.17-2.61,2.61-2.61h0"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppAliases);
export default __webpack_public_path__ + "static/media/AppAliases.7394699aaa48f74ee10fdbb3c030dd38.svg";
export { ForwardRef as ReactComponent };